import { TFunction } from 'i18next'

import { Manager } from '@/api/managers'
import { SortOrder } from '@/components/ui/table'
import { formatDateOnly } from '@/utils/date'

import { filterBySearch, getPersonFullName, sortItems } from '../shared/person-table.utils'
import { ManagerSortKey } from './managers.sort-keys'

export const getManagerFullName = (manager: Manager) => getPersonFullName(manager.user)

export const filterManagers = (managers: Manager[], search?: string) =>
  filterBySearch(managers, search, (manager) => [getManagerFullName(manager), manager.user.email])

const getSortValue = (manager: Manager, sortBy: ManagerSortKey) => {
  switch (sortBy) {
    case ManagerSortKey.createdAt:
      return manager.createdAt
    case ManagerSortKey.email:
      return manager.user.email.toLowerCase()
    case ManagerSortKey.name:
      return getManagerFullName(manager).toLowerCase()
    case ManagerSortKey.status:
      return manager.user.isActive ? 0 : 1
  }
}

export const sortManagers = (
  managers: Manager[],
  sortBy?: ManagerSortKey | null,
  sortOrder?: SortOrder | null,
) => sortItems(managers, sortBy, sortOrder, getSortValue)

export const getManagersCsvFields = (t: TFunction<['organisation']>) => [
  {
    label: t('organisation:managers.list.columns.name'),
    value: (row: Manager) => getManagerFullName(row),
  },
  {
    label: t('organisation:managers.list.columns.email'),
    value: (row: Manager) => row.user.email,
  },
  {
    label: t('organisation:managers.list.columns.status'),
    value: (row: Manager) =>
      row.user.isActive
        ? t('organisation:shared.status.active')
        : t('organisation:shared.status.inactive'),
  },
  {
    label: t('organisation:managers.list.columns.createdAt'),
    value: (row: Manager) => formatDateOnly(new Date(row.createdAt)),
  },
]
